import apiSDK from '@/services/apiSdk';
import { RECAPTCHA_HEADER } from '@/hooks/useRecaptcha';
import { useMutation } from '@tanstack/react-query';

export default function useAssumeToken() {
    const mutationFn = async ({
        userId,
        reCaptcha,
    }: {
        userId: number;
        reCaptcha: string;
    }) => {
        const { data } = await apiSDK.session.assumeToken(
            { userId },
            { headers: { [RECAPTCHA_HEADER]: reCaptcha } },
        );
        return data;
    };

    return useMutation({
        mutationFn,
    });
}
